import { render, staticRenderFns } from "./purchaseDetails.vue?vue&type=template&id=794faaf8&scoped=true&"
import script from "./purchaseDetails.vue?vue&type=script&lang=js&"
export * from "./purchaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./purchaseDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./purchaseDetails.vue?vue&type=style&index=1&id=794faaf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794faaf8",
  null
  
)

export default component.exports